/**
 * @module Page-Case-Study
 */

import { TypePageCaseStudy } from "../../@types/pageTypes";
import { useEffect, useState } from "react";
import { getCasesData } from "../../../api/case-service";
import { loadScript } from "../../../globals/common-functions";
import { BANNER_TYPE } from "../../../globals/constants";
import banner from '../../../globals/banner.json';
import SectionInnerPageBanner from "../../sections/common/banner";
import SectionCaseStudyCases from "../../sections/case-study/case-study-cases";
import SectionPagination from "../../sections/common/pagination";

function CaseStudyPage() {

    const _casesDefault: TypePageCaseStudy = {};
    const [results, setResults] = useState(_casesDefault);
    const [isFetching, setIsFetching] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;

    useEffect(() => {

        getCasesData((response: TypePageCaseStudy) => {
            setIsFetching(false);
            setResults(response);
            loadScript("js/custom.js");
        })

    }, [isFetching])

    const totalItems = results.cases?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const shouldShowPagination = totalItems > 12;

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = results.cases?.slice(startIndex, endIndex) || [];

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            window.scrollTo(0, 0);
        }
    };

    return (
        <div className="av-cs-v2">
            <SectionInnerPageBanner _data={banner.case_study} _type={BANNER_TYPE.COMPACT} />

            {
                results.cases &&
                <div className="section-full p-t120 p-b120 site-bg-white">
                    <div className="container">
                        <div className="av-cs-page-header">
                            <div className="av-sh-label">Our Work</div>
                            <h2>Projects We're Proud Of</h2>
                            <p>Real solutions we've built for real businesses. Take a look at what we've been working on.</p>
                        </div>
                        <div className="section-content">
                            <SectionCaseStudyCases _cases={currentItems} />
                            {shouldShowPagination && (
                                <SectionPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
export default CaseStudyPage;
